import { SecuredClient } from 'Core/Api/SecuredClient';
import { KnowledgeBotQueryCommandRequest, KnowledgeBotQueryCommandResponse } from 'Core/Api/Api';

export class KnowledgeBotHandler {
    constructor(props?: any) { }
    
    /**
     * Query the knowledge bot with user input
     * @param request KnowledgeBotQueryCommandRequest
     * @returns KnowledgeBotQueryCommandResponse
     */
    async queryKnowledgeBot(request: KnowledgeBotQueryCommandRequest): Promise<KnowledgeBotQueryCommandResponse> {
        const client = new SecuredClient();
        client.showLoading = false; // Keep loading state in component
        client.handleGeneralError = true;
       
        try {
            return await client.query(request);
        } finally {
            client.showLoading = false;
        }
    }
}